import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  right: 300px;
  top: 60px;
  width: 340px;
  background-color: green;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  position: absolute;
  z-index: 1000;
  color: #333;
  font-weight: 500;
  border-radius: 10px;

  // diagonal stripes background
  background: repeating-linear-gradient(
    45deg,
    #ffd700 0px,
    #ffd700 10px,
    #fabb0e 10px,
    #fabb0e 20px
  );
`;

export const Content = styled.div`
  padding: 35px 15px 15px;
  flex: 1;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px;
`;

export const Close = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;
